t = require('views/internal/teacup-with-helpers')('power_up_item_details')

module.exports = ->
  if t.mustacheVar('isGrandfathered')
    t.p '.power-up-grandfathered', ->
      t.format 'power-up-was-enabled-on-this-board-before-some-recent-changes-we-made', {
        name: t.mustacheVar('displayName')
      }
      t.text ' 🎉'

  t.p ->
    t.text t.mustacheVar('about')

  t.mustacheBlock 'showScreenshots', ->
    t.h4 ->
      t.format 'screenshots'

    t.mustacheBlock 'screenshots', ->
      t.img { src: t.mustacheVar('.'), alt: t.mustacheVar('name') + " Screenshot" }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_up_item_details.coffee